import { convertMoenyToInt, convertPercentageToFloat } from "../../../helpers/conversions";
import { impostos } from "./impostos";

export class Calculation {
    constructor(
        formulaSalePrice, 
        formulaCommission, 
        productQuantity, 
        productUnitCost, 
        productCustomizations, 
        productParams,
        params,
        taxPercentage,
        taxPIS,
        taxCOFINS,
        taxCSLL,
        taxIRPJ,
        taxAdicionaisIRPJ,
        destinacao,
        uf,
        productOrigem
    ) {
        this.formulaSalePrice = formulaSalePrice;
        this.formulaCommission = formulaCommission;
        this.productQuantity = productQuantity;
        this.productUnitCost = productUnitCost;
        this.productCustomizations = productCustomizations;
        this.productParams = productParams;
        this.params = params;
        this.taxPercentage = taxPercentage;
        this.taxPIS = taxPIS;
        this.taxCOFINS = taxCOFINS;
        this.taxCSLL = taxCSLL;
        this.taxIRPJ = taxIRPJ;
        this.taxAdicionaisIRPJ = taxAdicionaisIRPJ;
        this.uf = uf;
        this.destinacao = destinacao;
        this.origem = productOrigem;
    }

    getCommission = () => {
        let price = this.getSalePrice() / 100;
        price = price.toFixed(2);
        let formula = this.formulaCommission;
        formula = this.replaceFormulaParams(formula);

        formula = formula.replaceAll('[Preço de venda]', price);

        try {
            let result = eval(formula) * 100;
            return result;
        } catch (error) {
            return 0;
        }
    }

    getSalePrice = () => {
        let formula = this.formulaSalePrice;
        formula = this.replaceFormulaParams(formula);

        try {
            let result = eval(formula) * 100;
            return result;
        } catch (error) {
            return 0;
        }
    }

    replaceFormulaParams = formula => {
        let quantidade = this.productQuantity;
        let custo = convertMoenyToInt(this.productUnitCost) / 100;
        let gravacao = this.getCustomizationPrice() / 100;
        let customParams = this.getCustomParams();

        formula = formula.replaceAll('[Quantidade]', quantidade);
        formula = formula.replaceAll('[Custo unitário]', custo);
        formula = formula.replaceAll('[Gravação]', gravacao);

        formula = formula.replaceAll('[Imposto]', (this.taxPercentage / 1000000));
        formula = formula.replaceAll('[PIS]', (this.taxPIS / 1000000));
        formula = formula.replaceAll('[COFINS]', (this.taxCOFINS / 1000000));
        formula = formula.replaceAll('[CSLL]', (this.taxCSLL / 1000000));
        formula = formula.replaceAll('[IRPJ]', (this.taxIRPJ / 1000000));
        formula = formula.replaceAll('[Adicionais IRPJ]', (this.taxAdicionaisIRPJ / 1000000));

        formula = formula.replaceAll('[DIFAL]', this.getDifal());

        customParams.map(customParam => {
            formula = formula.replaceAll(`[${customParam.name}]`, customParam.value);
        });
        
        return formula;
    }

    getCustomizationPrice = () => {
        let result = 0;
        this.productCustomizations.map(productCustomization => {
            result += convertMoenyToInt(productCustomization.customizationTotalCost);
        });
        return result;
    }

    getCustomParams = () => {
        let params = [];

        this.productParams.map(productParam => {
            let param = this.getParam(productParam);
            if(param === null) return;

            let value = null;
            switch (param.type) {
                case 'quantity_and_price':
                    value = this.getQuantityAndPriceValue(productParam) / 100;
                    break;
                case 'multiple_value':
                    value = this.getMultipleValueValue(productParam) / 100;
                    break;
                case 'multiple_value_with_quantity':
                    value = this.getMultipleValueWithQuantityValue(productParam, param) / 100;
                    break;

                case 'percentage':
                    value = this.getPercentage(productParam);
                    break;

                case 'multiple_percentage':
                    value = this.getPercentage(productParam);
                    break;

                case 'extra':
                    value = this.getExtra(productParam) / 100;
                    break;

                case 'conditional_percentage':
                    value = this.getConditionalPercentage(param);
                    break;
            
                default:
                    break;
            }

            params.push({
                id: param.id,
                name: param.name,
                value
            });
        });
        return params;
    }

    getParam = productParam => {
        let currentParam = this.params.filter(param => param.id === productParam.id);
        return currentParam[0] ?? null;
    }

    getQuantityAndPriceValue = productParam => {
        let quantity = productParam.values[0] ?? 0;
        let value = productParam.values[1] ? convertMoenyToInt(productParam.values[1]) : 0;
        return quantity * value;
    }

    getMultipleValueValue = productParam => {
        return productParam.value ? convertMoenyToInt(productParam.value) : 0;
    }

    getMultipleValueValue = productParam => {
        return productParam.value ? convertMoenyToInt(productParam.value) : 0;
    }

    getMultipleValueWithQuantityValue = (productParam, param) => {
        let value = 0;
        param.options.map((option, index) => {
            if(productParam.values[index]){
                let optionValue = convertMoenyToInt(option.value);
                let quantity = productParam.values[index];
                value += optionValue * quantity;
            }
        });

        return value;
    }

    getPercentage = productParam => {
        let value = productParam.value ? convertPercentageToFloat(productParam.value) : 0;
        return value;
    }

    getExtra = productParam => {
        let result = 0;
        productParam.values.map(value => {
            result += convertMoenyToInt(value);
        });
        return result;
    }

    getConditionalPercentage = param => {
        let result = 0;
        let productParamParents = this.productParams.filter(productParam => productParam.id === param.param_id);
        let productParamParent = productParamParents[0];

        if(productParamParent === undefined) return 0;

        param.options.map(option => {
            if(option.related_percentage === productParamParent.value){
                result = convertPercentageToFloat(option.value);
            }
        });

        return result;
    }

    getHasDifal = () => {
        return this.uf + '.';
    }

    getImposto = () => {
        if(!this.origem || !this.uf){
            return null;
        }
        let origem = this.origem === "0" ? "NAC" : "IMP";
        let uf = this.uf;
        return impostos.filter(imposto => imposto.uf === `${uf} ${origem}`)[0];
    }

    getDifal = () => {
        let imposto = this.getImposto();
        return imposto ? parseFloat(imposto.difal) : 0;
    }

    getStSaida = () => {
        if(this.destinacao !== null && this.destinacao !== 'consumo') {
            return 0;
        }

        let total = this.getSalePrice() * this.productQuantity;
        let imposto = this.getImposto();
        if(!imposto) return 0;

        let aliquota_interestadual = parseFloat(imposto.aliquota_interestadual);
        let aliquota_interna = parseFloat(imposto.aliquota_interna);
        let ICMSDestacado =  aliquota_interestadual * total;
        let totalSemICMS = total - ICMSDestacado;
        let aliquotaInternaPorDentro = 1 - aliquota_interna;
        let baseCalculoAjustado = totalSemICMS / aliquotaInternaPorDentro;
        let valorICMSBCAjustado = baseCalculoAjustado * aliquota_interna;

        return valorICMSBCAjustado - ICMSDestacado;
    }

}